export const ADD_NEW_FOLDER = "ADD_NEW_FOLDER";
export const REMOVE_NEW_FOLDER = "REMOVE_NEW_FOLDER";
export const CLEAR_NEW_FOLDERS = "CLEAR_NEW_FOLDERS";
